import React from "react";
import { useSelector } from "react-redux";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";

const MembershipDetailsChart = () => {
  const {
    data_table: { rows = [], cols = [] },
    options
  } = useSelector((state) => state.membershipUnits.chartData);

  return (
    <GoogleChart
      chartName="dashboard_membership_breakdown_chart"
      width="1350px"
      height={350}
      chartType="LineChart"
      rows={rows}
      columns={cols}
      options={options}
      enableLineChartTooltip
    />
  );
};

export default MembershipDetailsChart;
